import React from 'react';
import { connect } from 'react-redux';
import './index.scss';
import * as WidgetActions from './actions';
import Tracker from '../../../genesys/tracker';
import View from '../../views';

class WidgetLayer extends React.Component {
    componentDidMount() {
        Tracker.sendEvent('widgetOpened');
    }

    componentWillUnmount() {
        Tracker.sendEvent('widgetClosed');
    }

    render() {
        const { config, widget } = this.props;

        const classes = [
            'widget-layer',
            widget.widgetDisplay.toLowerCase(),
            config.theme ? config.theme : 'default'
        ];

        return (
            <div id="widget" className={classes.join(' ')}>
                <View
                    view={widget.currentView}
                    mode={widget.currentMode}
                    viewConfig={config}
                    layerConfig={widget}
                    events={{
                        minimize: WidgetActions.onMinimize,
                        maximize: WidgetActions.onMaximize,
                        close: WidgetActions.onClose
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        main: state.main,
        options: state.options,
        config: state.config.widget,
        widget: state.widget,
        chat: state.chat,
        settings: state.settings
    };
};

export default connect(mapStateToProps)(WidgetLayer);
